import { formatDistanceStrict, format, isToday } from 'date-fns'

export default ( date ) => {
    if ( !isToday(date) ) return format(date,'dd/MM/yy')
    return formatDistanceStrict(Date.now(),date)+ ' ago';  
}